<template>
  <div class="modal__login">
    <h3 class="modal__header">
      {{ options.header }}
    </h3>

    <div class="modal__text" v-html="options.text">
    </div>

    <oie-sign-in-box
      register-url="registerUrl"
      :return-url="options.returnUrl"
      :fetch-invoice-data="true">
    </oie-sign-in-box>

    <div class="modal__actions">
      <oie-base-button
        v-for="button in options.buttons"
        :key="button.text"
        :css-classes="button.usePrimaryButton ? 'button--with-border button--blue' : 'button--true-ghost'"
        :text="button.text"
        @click="button.handler(button.handlerParams)"></oie-base-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss">
.modal__actions {
  display: flex;
  align-items: center;
}

.modal__actions > * + * {
  margin-left: measure(quarter);
}
</style>
